import React from "react";
import { Tabs, Tab } from "@madie/madie-design-system/dist/react";

export interface NavTabProps {
  activeTab: string;
  setActiveTab: (value: string) => void;
  functionCount: number;
  loading: boolean;
}

export default function FunctionSectionNavTabs(props: NavTabProps) {
  const { activeTab, setActiveTab, functionCount, loading } = props;

  return (
    <div style={{ borderBottom: "1px solid #b0b0b0" }} tw="flex flex-row">
      <Tabs
        id="function-tabs"
        value={activeTab}
        onChange={(e, v) => {
          setActiveTab(v);
        }}
        type="B"
        visibleScrollbar
        variant="scrollable"
        scrollButtons={false}
      >
        <Tab
          tabIndex={0}
          aria-label="Function"
          type="B"
          label="Function"
          data-testid="function-tab"
          value="function"
        />
        <Tab
          tabIndex={0}
          aria-label="Saved Functions"
          type="B"
          label={`Saved Functions ${!loading ? "(" + functionCount + ")" : ""}`}
          data-testid="saved-functions-tab"
          value="saved-functions"
        />
      </Tabs>
    </div>
  );
}
